import { IData } from '../interface';

const render = (data: IData) => {
    const SYSTEM_SCRIPT_MAP = {
        '"CN"': '<script src="https://statics-cdn-cn.umucdn.cn/cdn/js/jweixin-1.6.0.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        'CN': '<script src="https://statics-cdn-cn.umucdn.cn/cdn/js/jweixin-1.6.0.js?v={{pageData.version | default(0)}}" type="text/javascript"></script>',
        '"EN"': '',
        'EN': '',
        '"EM"': '',
        'EM': '',
        '"JP"': '',
        'JP': '',
        '"TW"': '',
        'TW': '',
    };

    return SYSTEM_SCRIPT_MAP[data.SYSTEM] || '';
};

export default render;
